import React, {useEffect} from 'react'
import { useHistory } from 'react-router';

import {Button} from "@mui/material";
import GoogleRating from './components/GoogleRating';

export default function Landing() {
    const history = useHistory();

    useEffect(() => {
        const body = document.getElementsByTagName('body')
        body[0].classList.add('bodyWithoutPadding')
        return () => {
            body[0].classList.remove('bodyWithoutPadding')
        }
    }, []);

    const goSignUp = () => {
        history.push({
            pathname: 'RoleSelect'
        });
    }

    const goLogin = () => {
        history.push({
            pathname: 'Login'
        });
    }

    let logoStyle = {};

    if (window.cordova) {
        logoStyle = {paddingTop: 'env(safe-area-inset-top)'}
    }

    if (window.location.search.indexOf('resetPasswordToken') !== -1) {
        history.push({
            pathname: 'ResetPassword'
        });
    }

    return (
        <div data-page="index" className={'page no-swipeback landing unsetBackground'}>
            <div id="landingBackground" className="landingBackground"></div>
            <div className="landingBackground2"></div>

            <div className="page-content center landingPage">

                <div className="landingLogo" style={logoStyle}>
                    <img className="tempstars-logo-icon centerImg" src="img/logoBlue.svg"/>
                </div>

                <div className="content-block fullheight-contentContainer">
                    <div>
                        <div></div>
                        <div className="seoBlock">
                            <div className="seoText">James Younger, DDS</div>
                            <div className="seoSubtext">FOUNDER & CEO</div>
                        </div>
                    </div>
                    <div className="contentContainer">
                        <div className="row">
                            <div className="headerText">Dental Temping & Hiring Done Right.</div>
                        </div>

                        <div className="row">
                            <div className="subHeaderText">Top Dental Professionals + Great Offices</div>
                        </div>

                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            id="signup-button"
                            className="bigButtonInNewStyle MuiButton-containedPrimary"
                            onClick={goSignUp}
                        >
                            Sign Up
                        </Button>


                        <div className="alreadyHaveAcc">
                            Already have an account?
                        </div>

                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            id="signup-button"
                            className="bigButtonInNewStyle transparentButton"
                            onClick={goLogin}
                        >
                            Login
                        </Button>

                        <GoogleRating rating={4.5} reviews={700} />
               
                    </div>
                </div>
            </div>

        </div>
    )
}
